export * from './ICategoryColumnConfigurationResult';
export * from './IColumnConfigurationResult';
export * from './IColumnResult';
export * from './IDividedBettingTypesResult';
export * from './IFiveColumnsResult';
export * from './ValidColumns';